import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["topBar", "navWrapper"];

  get navWrapperHeight() {
    const nav = document.querySelector("#top-navigation-bar");
    const banner = document.querySelector(".banner");
    const screenWidth = document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth;

    if ( window.devicePixelRatio >= 2 && screenWidth <= 767) {
      return 0
    }

    // Considering banner height as well if banner is displayed
    return ((nav?.offsetHeight || 0) + (banner?.offsetHeight || 0)) || 0;
  }

  get topBarHeight() { return this.topBarTarget.offsetHeight; }

  get offlineBannerOffset() {
    const banner = document.querySelector(".fixed-top-banner:not([hidden])");
    if (!banner) return 0;
    const syncStatus = document.querySelector(".sync-status:not(.hidden)");
    return banner.offsetHeight + (syncStatus ? syncStatus.offsetHeight : 0);
  }

  get docBodyWrapper() { return document.querySelector("#doc-body-wrapper"); }

  get screenWidth() { return document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth; }

  connect() {
    this.lastScrollTop = window.scrollY;
    this.delta = 2;

    // Ensure bar is visible on page load
    this.showBar();

    this.resizeTimeout = null;
    this.resizeObserver = new ResizeObserver(() => {
      if (this.resizeTimeout) cancelAnimationFrame(this.resizeTimeout);
      this.resizeTimeout = requestAnimationFrame(() => {
        this.handleResize();
        this.resizeTimeout = null;
      });
    });

    this.resizeObserver.observe(document.body);

    this.scrollHandler = this.handleScroll.bind(this);
    window.addEventListener("scroll", this.scrollHandler);

    this.boundShowBar = this.showBar.bind(this);
    window.addEventListener("online", this.boundShowBar);
    window.addEventListener("offline", this.boundShowBar);
  }

  disconnect() {
    window.removeEventListener("scroll", this.scrollHandler);
    window.removeEventListener("online", this.boundShowBar);
    window.removeEventListener("offline", this.boundShowBar);

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

    if (this.resizeTimeout) {
      cancelAnimationFrame(this.resizeTimeout);
    }
  }

  handleScroll() {
    const currentScroll = window.scrollY;

    // Always show bar if at top
    if (currentScroll === 0) {
      this.showBar();
      this.lastScrollTop = currentScroll;
      return;
    }

    // Always show bar if above navWrapperHeight
    if (currentScroll <= this.navWrapperHeight) {
      this.showBar();
      this.lastScrollTop = currentScroll;
      return;
    }

    // Only trigger if scroll changed enough
    if (Math.abs(this.lastScrollTop - currentScroll) <= this.delta) return;

    if (currentScroll > this.lastScrollTop) {
      // Scrolling down
      this.hideBar();
    } else if (currentScroll < this.lastScrollTop) {
      // Scrolling up (even slightly)
      this.showBar();
    }

    // Always update scroll position
    this.lastScrollTop = currentScroll;
  }

  handleResize() {
    this.showBar();
  }

  showBar() {
    this.topBarTarget.style.transition = "top 0.3s ease-in-out";
    // Position below #top-navigation-bar
    const nav = document.querySelector("#top-navigation-bar");
    const navHeight = nav ? nav.offsetHeight : 60;
    this.topBarTarget.style.setProperty("top", `${navHeight + this.offlineBannerOffset}px`, "important");
    // Set margin-top for #root to match sticky-info bar height if the bar is tall (>= 120px), or #top-navigation-bar is visible, or screen width <= 767px
    const root = document.querySelector(".root");
    const navVisible = nav && nav.offsetHeight > 0 && window.getComputedStyle(nav).display !== "none";
    const screenWidth = this.screenWidth;
    if (root) {
        if (this.topBarTarget.offsetHeight >= 120 || navVisible || screenWidth <= 767) {
        root.style.marginTop = `${this.topBarTarget.offsetHeight}px`;
      } else {
        root.style.marginTop = null;
      }
    }
  }

  hideBar() {
    this.topBarTarget.style.transition = "top 0.3s ease-in-out";
    this.topBarTarget.style.setProperty("top", `-${this.topBarHeight}px`, "important");
  }
}
